
import React, { useState } from 'react';
import { Container, Box } from '@mui/system';
import { Button, Grid } from '@mui/material';
import { useHistory } from 'react-router-dom';

// block groups
import SearchField from '../../../blockGroups/search/SearchField/SearchField.blockgroup';
import BaseTable from '../BaseTable/BaseTable.blockgroup';

// algorithms
import { filterDataObjectListBySearch } from '../../../shared/filtering/search';

// hooks
import { useTableSearch } from '../../../shared/hooks/useTableSearch';

// utils
import { generateSearchParamString } from '../../../shared/utility';

const TableWithSearch = ({ rawData = [], 
    loading, 
    searchFieldOptions = [], 
    columnConfigs = [], 
    error, 
    onRowClick, 
    addButtonConfig = null, 
    sortModel = [], 
    onSortModelChange,
    pageProps = {},
 }) => {
    
    const history = useHistory()

    // Variables
    const { searchValue, searchBy } = useTableSearch(pageProps.location.search)

    // triggered when Search Button is clicked
    const handleSearchClicked = (searchValue, searchBy) => {
        // update the searchParams
        const { search, pathname } = pageProps.location
        history.push(`${pathname}${generateSearchParamString(search, {
            "searchValue": searchValue,
            "searchBy": searchBy
        })}`)
    }

    const handleClearSearchClicked = () => {
        // update the searchParams
        const { search, pathname } = pageProps.location
        history.push(`${pathname}${generateSearchParamString(search, {}, {
            "searchValue": "",
            "searchBy": ""
        })}`)
    }

    const results = filterDataObjectListBySearch(rawData, searchValue, searchBy)

    // Output
    // A list of either the raw data or results that have been filtered by the user’s search criteria
    return (<Container maxWidth={false} disableGutters>
        <Grid container>
            <Grid item xs={addButtonConfig ? 10 : 12}>
                <SearchField 
                    initialSearchBy={searchBy ? searchBy : ""}
                    initialSearchValue={searchValue ? searchValue : ""}
                    fieldOptions={searchFieldOptions}
                    onSearchClicked={handleSearchClicked}
                    onClearClicked={handleClearSearchClicked}
                />
            </Grid>

            {
                addButtonConfig && <Grid container item xs={2} justifyContent="flex-end">
                    <Button variant="contained" onClick={addButtonConfig.onClick}>{addButtonConfig.text}</Button>
                </Grid>
            }
            
        </Grid>
        
        <Box
        sx={{ height: "70vh", width: "100%", marginTop: 2 }}
        >
            <BaseTable 
                rawData={results ? results : rawData}
                columnConfigs={columnConfigs}
                loading={loading}
                onRowClick={onRowClick}
                sortModel={sortModel}
                onSortModelChange={onSortModelChange}
            />
        </Box>
         
    </Container>)
}

export default TableWithSearch;